import type {SyntheticEvent} from 'react';

import {InlineTextButton} from 'shells/button/inline-text-button/inline-text-button';

interface Props {
    recommendationError: unknown | null;
    pageError: unknown | null;
    nextPageError: unknown | null;
    isLoadingNextPage: boolean;
    retryRecommendations: () => void;
    retryPage: () => void;
}

function RetryMessage({message, onRetry}: {message: string; onRetry: () => void}) {
    const handleRetry = (event: SyntheticEvent) => {
        event.preventDefault();
        event.stopPropagation();
        onRetry();
    };

    return (
        <div className='px-12 py-8 font-size-small'>
            {message} <InlineTextButton onClick={handleRetry}>Try again</InlineTextButton>
        </div>
    );
}

export function PaginatedProductMenuStatus(props: Props) {
    return (
        <>
            {props.recommendationError && (
                <RetryMessage
                    message='Recommendations could not be loaded.'
                    onRetry={props.retryRecommendations}
                />
            )}
            {props.pageError && (
                <RetryMessage message='Products could not be loaded.' onRetry={props.retryPage} />
            )}
            {props.nextPageError && (
                <RetryMessage
                    message='More products could not be loaded.'
                    onRetry={props.retryPage}
                />
            )}
            {props.isLoadingNextPage && (
                <div className='px-12 py-8 font-size-small'>Loading more products…</div>
            )}
        </>
    );
}
